import React from 'react';

import { Skeleton, Stack, Typography } from '@mui/material';
import Button from '@mui/material/Button';

import useHeroPlannerOfferDetails from '~/hooks/customerCommunication/useHeroPlannerOfferDetails';

import { Dayjs } from '~/services/TimeService';

import { isRequestFulfilled, isRequestPending, isRequestRejected } from '~/utils/requestUtils';

import { isLuxPlusMonthCampaign } from '../../utils/heroPlannerScheduleUtils';
import LuxPlusMonthChip from '../LuxPlusMonthChip';

interface Props {
  countryGroupId: string;
  countryId: string;
  offerId: string;
  sendDate: Dayjs;
}

function ScheduleDealDetailsBlock({ countryGroupId, countryId, offerId, sendDate }: Props) {
  const { offerDetails } = useHeroPlannerOfferDetails(countryGroupId, countryId, offerId);

  return (
    <Stack direction="column">
      <Typography variant="caption">
        <b>Offer ID:</b> {offerId}
      </Typography>
      {isRequestFulfilled(offerDetails) && isLuxPlusMonthCampaign(offerDetails.result.campaign, sendDate) && (
        <LuxPlusMonthChip sx={{ width: 'fit-content' }} />
      )}
      <Typography variant="body2" color={isRequestRejected(offerDetails) ? 'error' : undefined}>
        <b>Price:</b> {(!offerDetails || isRequestPending(offerDetails)) && <Skeleton width={100} />}
        {isRequestFulfilled(offerDetails) && (
          <>
            {offerDetails.result.durationLabel} {offerDetails.result.formattedPrice} {offerDetails.result.roomType}
          </>
        )}
        {isRequestRejected(offerDetails) && <i>COULD NOT FETCH</i>}
      </Typography>
      <Typography variant="body2" color={isRequestRejected(offerDetails) ? 'error' : undefined}>
        <b>Name:</b> {(!offerDetails || isRequestPending(offerDetails)) && <Skeleton width={100} />}
        {isRequestFulfilled(offerDetails) && offerDetails.result.name}
        {isRequestRejected(offerDetails) && <i>COULD NOT FETCH</i>}
      </Typography>
      <Typography variant="body2" color={isRequestRejected(offerDetails) ? 'error' : undefined}>
        <Button
          variant="text"
          size="small"
          loading={!offerDetails || isRequestPending(offerDetails)}
          disabled={isRequestRejected(offerDetails)}
          href={offerDetails?.result?.offerLink}
          target="_blank"
        >
          View offer
        </Button>
      </Typography>
    </Stack>
  );
}

export default ScheduleDealDetailsBlock;
